import _ from 'lodash';
import angular from 'angular';
import { stemmer } from 'stemmer';

class SearchController {
  /* @ngInject */
  constructor(
    $rootScope,
    $scope,
    $state,
    $location,
    $q,
    $timeout,
    ApiService,
    nearBottomService
  ) {
    const vm = this;

    vm.$onInit = () => {
      $rootScope.pageTitle = 'Categories';
      // $rootScope.pageDescription = ''

      const categoriesMap = {};
      vm.categories.terms.forEach((category) => {
        categoriesMap[category.slug] = category;
      });

      const arrayify = (input) => {
        if (!input) {
          return [];
        }
        return angular.isArray(input) ? input : [input];
      };

      if (!$rootScope.searchCache) {
        $rootScope.searchCache = {};
      }

      let bookmark;
      let query;

      vm.results = [];

      const chunkLength = 15;

      nearBottomService.percent = 0.5;

      const search = (chips, bookmark = null) =>
        $q((resolve, reject) => {
          vm.searching = true;

          const tokens = [];

          chips.forEach((chip) => {
            let mod = '';
            let token;

            if (['-', '+'].indexOf(chip.slug[0]) > -1) {
              mod = chip.slug[0];
              token = chip.slug.slice(1);
            } else {
              token = chip.slug;
            }

            token = token.replace(/(-|–|—)/g, ' '); // replace hyphens/dashes with spaces

            // TODO: modifier should determine AND/OR

            _.uniq([token, stemmer(token)]).forEach((t) => {
              if (/terms/.test(chip.type)) {
                tokens.push(`${mod}fields.artist:${t}*^0.01`);
                tokens.push(`${mod}fields.caption:${t}*^1`);
                tokens.push(`${mod}fields.project:${t}*^1`);
                tokens.push(`${mod}fields.client:${t}*^1`);
              }
              if (/terms|categories/.test(chip.type)) {
                tokens.push(`${mod}fields.title:${t}*^1`);
              }
              tokens.push(`${mod}fields.categories.slug:${t}*^0.1`);
              tokens.push(`${mod}fields.tags.slug:${t}*^0.1`);
            });
          });

          query = `(schema:"folio"^2 OR schema:"image"^0.01 OR schema:"video"^0.01) AND !fields.assets:NULL AND (${tokens.join(
            ' OR '
          )})`;

          if (vm.results.length === 0 && $rootScope.searchCache[query]) {
            vm.searching = false;

            resolve($rootScope.searchCache[query]);

            return;
          }

          ApiService.entitySearch({
            q: query,
            children: 1,
            limit: chunkLength,
            bookmark,
          }).then((result) => {
            vm.searching = false;

            resolve(result);
          }, reject);
        });

      const appendResults = () => {
        search(vm.chips, bookmark).then((result) => {
          bookmark = result.bookmark;

          vm.results = vm.results.concat(result.rows);

          $rootScope.searchCache[query] = {
            bookmark,
            rows: vm.results,
          };
        });
      };

      $scope.$on('nearBottom', appendResults);

      $scope.$watch(
        () => $location.search(),
        (params) => {
          // console.log(params)

          vm.asset = null;

          vm.chips = [];

          if (params.categories) {
            arrayify(params.categories).forEach((categorySlug) => {
              if (categoriesMap[categorySlug]) {
                vm.chips.push({
                  type: 'categories',
                  slug: categorySlug,
                  title: categoriesMap[categorySlug].title,
                });
              }
            });
          }

          if (params.tags) {
            arrayify(params.tags).forEach((tag) => {
              vm.chips.push({
                type: 'tags',
                slug: tag,
                title: tag,
              });
            });
          }

          if (params.terms) {
            arrayify(params.terms).forEach((term) => {
              vm.chips.push({
                type: 'terms',
                slug: term,
                title: term,
              });
            });
          }

          if (vm.chips.length === 0) {
            vm.results = [];

            return;
          }

          search(vm.chips).then((result) => {
            bookmark = result.bookmark;

            vm.results = result.rows;

            $rootScope.searchCache[query] = {
              bookmark,
              rows: vm.results,
            };

            const terms = vm.chips.map((chip) => chip.title).join('\n- ');

            vm.emailSubject = 'Help?!';
            vm.emailBody = encodeURIComponent(`Hi there!

        Please can you send me a custom PDF, I'm looking for the following:

        - ${terms}

        Thanks!
        `);

            if (vm.results.length === 0) {
              vm.showPopup = true;
            }
          });
        }
      );

      const addTerm = (type, term) => {
        const search = $location.search() || {};
        let terms = arrayify(search[type]);

        terms.push(term);

        search[type] = terms;

        if (typeof ga !== 'undefined') {
          window.ga('send', 'event', 'Search', type, term);
        }

        $location.search(search);
      };

      const removeTerm = (type, term) => {
        const search = $location.search() || {};
        let termSlugs = arrayify(search[type]);

        termSlugs = termSlugs.filter((termSlug) => termSlug !== term.slug);

        search[type] = termSlugs;

        $location.search(search);
      };

      vm.clickCategory = (event, category) => {
        event.preventDefault();

        addTerm('categories', category.slug);
      };

      vm.clickChip = (event, chip) => {
        removeTerm(chip.type, chip);
      };

      vm.keypressSearch = (event) => {
        if (event.keyCode === 13) {
          addTerm('terms', vm.searchTerm);

          vm.searchTerm = null;
        }
      };

      vm.resultRatio = (result) => {
        try {
          if (
            result.schema === 'folio' &&
            result.fields.assets[0] &&
            result.fields.assets[0].schema === 'video'
          ) {
            return (
              result.fields.assets[0].fields.clip.metadata.width /
              result.fields.assets[0].fields.clip.metadata.height
            );
          }
          if (
            result.schema === 'folio' &&
            result.fields.assets[0] &&
            result.fields.assets[0].schema === 'image'
          ) {
            return result.fields.assets[0].thumbnail.ratio;
          }
          if (result.schema === 'video' && result.fields.clip) {
            return (
              result.fields.clip.metadata.width /
              result.fields.clip.metadata.height
            );
          }
          if (result.schema === 'image') {
            return result.thumbnail.ratio;
          }
        } catch (error) {
          //
        }
        return 1.778;
      };

      vm.parentHref = (parent) =>
        $state.href('index.artist.folio', {
          artistSlug: parent.fields.artist[0].slug,
          folioSlug: parent.slug,
          // i: _.findIndex(parent.fields.assets, asset => asset.id === result._id),
          i: vm.asset._id,
        });

      vm.clickResult = (event, result) => {
        vm.asset = result;

        ApiService.entityByIdOne({
          id: vm.asset._id,
          parents: ['[*schema=folio]'],
        }).then((entity) => {
          vm.asset.parents = entity.parents;
        });
      };

      $timeout(() => {
        if (!vm.chips.length) {
          vm.showPopup = true;
        }
      }, 5000);
    };
  }
}

export default SearchController;
